<template>
  <div style="width: 100%; background-color: #f7f7f7;">
    <div class="manage-title">
      <div class="manage-line"></div>
      <div class="manage-text">团队管理</div>
    </div>

    <van-collapse v-model="activeNames">
      <van-collapse-item v-for="(item, index) in listTabDepartment" :key="index" :title="item.name" :name="item.name" style="margin-bottom: 12px;" :border="false">
          <van-cell-group v-for="(data, index) in item.departmentDatas" :key="index">
            <van-swipe-cell>
              <div class="flex-container">
                <van-image round width="50px" height="43px" :src="data.img" />
                <van-cell :label="data.account" :border="false">
                      <!-- 使用 title 插槽来自定义标题 -->
                      <template #title> 
                        <div class="manage-tags">
                          <div>{{data.name}}</div>
                          <div style="color:#3a71ffff; margin-left: 6px">{{getIsLeaderName(data, item.userId)}}</div>
                        </div>
                      </template>
                  </van-cell>
              </div>
              <template #right>
                <van-button square type="warning" text="添加组员" v-show="getIsLeader(data, item.userId)" @click="onClickAdd(data)"/>
                <van-button square type="danger" text="撤销组长" v-show="getIsLeader(data, item.userId)" @click="onClickCancelLeads(data)"/>
                <van-button square type="info" text="重新分配"  v-show="!getIsLeader(data, item.userId)" @click="onClickAssigne(data)"/>
            </template>
          </van-swipe-cell>
        </van-cell-group>
      </van-collapse-item>
      <van-collapse-item title="待分配成员" style="margin-bottom: 12px;" :border="false"  name="待分配成员">
          <van-cell-group v-for="(item, index) in undistributedData" :key="index">
            <van-swipe-cell>
              <div class="flex-container">
                <van-image round width="50px" height="43px" :src="item.img" />
                <van-cell :label="item.account" :border="false">
                      <!-- 使用 title 插槽来自定义标题 -->
                      <template #title> 
                        <div class="manage-tags">
                          <div>{{item.name}}</div>
                        </div>
                      </template>
                  </van-cell>
              </div>
              <template #right>
                <van-button square type="warning" text="设置组长" @click="onClickSetLeads(item)"/>
                <van-button square type="info" text="进行分配" @click="onClickAssigne(item)"/>
            </template>
          </van-swipe-cell>
        </van-cell-group>
      </van-collapse-item>
    </van-collapse>
  </div>
</template>

<script>

import request from "@/utils/request";
import { Toast } from 'vant';

export default {
   props: {
    firmId: {
      type: String,
      default: ""
    },
  },
  data() {
    return {
      listTabDepartment: [],
      activeNames: [],
      undistributedData: [],
      listQueryDepartment: {
        pageInfo: {
          pageSize: 1000,
          page: 1,
          totalCount: 0
        },
        orderBy: "createTime",
        orderAsc: false,
        departmentId: "",
        firmId: "",
      },
    };
  },
  created() {
    this.onLoadDepartmentTab()
    this.getUndistributedList();
  },

  methods: {
    onClickAdd(item) {
      this.$router.push({
        path: 'teamAddMembers',
        query: { departmentId: item.departmentId, firmId: this.firmId }
      })
    },
    onClickAssigne(item) {
      this.$router.push({
        path: 'teamAssigne',
        query: { userId: item.id, firmId: this.firmId }
      })
    },
    getIsLeaderName(item, leaderUserId) {
      return this.getIsLeader(item, leaderUserId) ? "组长" : "组员"
    },
    getIsLeader(item, leaderUserId) {
      return item.id === leaderUserId
    },
     /**
     * 获取未分配用户列表
     */
    getUndistributedList() {
     request.get("/User/Department/GetUndistributedList", { params: { firmId: this.firmId }})
        .then((res) => {
         this.undistributedData = res.data.data
        })
        .catch(() => {});
    },
     /**
     * 设置组长
     */
    onClickSetLeads(item) {
     request.get("/User/Department/SetLeads", { params: { id: item.id } })
        .then(() => {
          Toast("操作成功");
          this.onLoadDepartmentTab()
          this.getUndistributedList();
        })
        .catch(() => {});
    },
     /**
     * 撤销组长
     */
    onClickCancelLeads(item) {
     request.get("/User/Department/CancelLeads", { params: { id: item.id } })
        .then(() => {
          Toast("操作成功");
          this.onLoadDepartmentTab()
          this.getUndistributedList();
        })
        .catch(() => {});
    },
    onLoadDepartmentTab() {
      request.get("/User/Department/GetDepartmentList", { params: { firmId: this.firmId }})
        .then((res) => {
          this.listTabDepartment = res.data.data
          this.listTabDepartment.forEach(action => {
              this.onLoadDepartment(action.id)
          });
        })
        .catch(() => {});
    },
     onLoadDepartment(value) {
      this.listQueryDepartment.departmentId = value
      this.listQueryDepartment.firmId = this.firmId;

      var filterFomr = Object.assign({}, this.listQueryDepartment);
      request.post("/User/MyTeam/DepartmentUserList", filterFomr).then((res) => {
         this.listTabDepartment.forEach(action => {
          if(action.id === res.data.data.departmentId) {
            action.departmentDatas = res.data.data.data;
          }
             
          });
      }).catch(() => {
      });
    },
  }
};
</script>

<style lang="less">
.flex-container {
  display: flex;
  align-items: center;
  justify-content: space-between; /* 或者使用 flex-start, flex-end, center, space-around, space-evenly 等 */
}

.manage-title {
  display: flex;
  align-items: center;
  background-color: #fff;
  padding: 12px;
  width: 100%;
}

.manage-tags {
  display: flex;
  align-items: center;
}

.manage-center {
  display: flex;
  align-items: center;
  justify-content: right;
  padding: 12px;
}

.manage-line {
  background-color: #3a71ffff;
  border-radius: 4px;
  margin: 3px;
  width: 4px;
  height: 16px;
}

.manage-text {
  color: #333;
  margin-left: 6px;
}

.manage-content {
  padding-right: 20px;
  text-align: right;
  color: #333;
  border: none;
  width: 95%;
}

</style>
